<template>
	<div class="setting_ps px-7 py-4">
		<div style="position: absolute; right: 0px; top: 0px" class="px-7 pt-4">
			<v-row no-gutters>
				<v-col cols="12" class="text-right mt-2 pr-3">
					<SecondaryButton @click="connectDomain">Connect Domain</SecondaryButton>
					<ConnectCnameDialog :showDialog.sync="connectDialog" />
				</v-col>
			</v-row>
		</div>
		<v-row no-gutters>
			<v-col cols="12" class="px-3">
				<SettingsTable title="Domains" :sourceList="flattenCnames">
					<template v-slot:item="{ item: cname }">
						<CnameListItem class="mb-2" :key="`${cname.serviceId}__${cname.cname}`" :cnameData="cname" />
					</template>
				</SettingsTable>
			</v-col>
		</v-row>
	</div>
</template>

<script>
import ConnectCnameDialog from '@/components/Settings/CnamesConnectNewDialog';
import CnameListItem from '@/components/Settings/SettingsCnamesListItem';
import SettingsTable from './SettingsTable';
import { mapGetters } from 'vuex';
export default {
	name: 'SettingsCnames',
	components: {
		CnameListItem,
		ConnectCnameDialog,
		SettingsTable,
	},
	computed: {
		...mapGetters('account', ['flattenCnames']),
	},
	methods: {
		connectDomain() {
			this.connectDialog = true;
		},
	},
	mounted() {},
	data: () => ({
		connectDialog: false,
	}),
};
</script>

<style scoped></style>
